export const sogCutoverDates: Record<string, string> = {
  'ESALG-ESCEU': '2026-12-01',
  'ESALG-MAPTM': '2026-11-10',
  'ESCEU-ESALG': '2026-12-01',
  'MAPTM-ESALG': '2026-11-10',
}
